import axios from 'axios'
import {
  Bar,
  LibrarySymbolInfo,
  ResolutionString,
  SearchSymbolsCallback,
  SubscribeBarsCallback,
} from '../../charting_library/charting_library'
import moment from 'moment'
import {
  calculateIntervalTime,
  convertedInterval,
  symbolChartRequest,
} from '../function'

export default ({ widgetRef, periodRef, socketIo }: any) => ({
  onReady: async (callback: any) => {
    const { data } = await axios.get(
      `${process.env.REACT_APP_DATA_PLATFORM_API_URL}/trading-view/config`,
    )

    callback(data)
  },
  searchSymbols: async (
    userInput: string,
    exchange: string,
    symbolType: string,
    onResult: SearchSymbolsCallback,
  ) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_DATA_PLATFORM_API_URL}/trading-view/search?query=${userInput}&type=&exchange=${exchange}&limit=999`,
      )

      onResult(data)
    } catch (error) {
      onResult([])
    }
  },
  resolveSymbol: async (
    symbolName: any,
    onSymbolResolvedCallback: any,
    onResolveErrorCallback: any,
  ) => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_DATA_PLATFORM_API_URL}/trading-view/symbols?symbol=${symbolName}`,
      )

      onSymbolResolvedCallback({
        ...data,
        intraday_multipliers: data.supported_resolutions,
        has_intraday: true,
      })
    } catch (error) {
      onResolveErrorCallback(error)
    }
  },
  getBars: async (
    symbolInfo: any,
    resolution: any,
    periodParams: any,
    onHistoryCallback: any,
    onErrorCallback: any,
  ) => {
    const { from, to } = calculateIntervalTime(
      periodParams.firstDataRequest,
      periodParams.from,
      periodParams.to,
      periodRef,
      widgetRef.current?.symbolInterval()?.interval,
    )

    const { bars, meta } = await symbolChartRequest(
      symbolInfo.ticker,
      from,
      to,
      widgetRef.current?.symbolInterval()?.interval,
      onErrorCallback,
    )

    onHistoryCallback(bars, meta)
  },
  subscribeBars: async (
    symbolInfo: LibrarySymbolInfo,
    resolution: ResolutionString,
    onTick: SubscribeBarsCallback,
  ) => {
    const convertedResolution = convertedInterval(
      widgetRef.current?.symbolInterval()?.interval,
    )

    socketIo.current?.close()

    socketIo.current = new WebSocket(
      `${process.env.REACT_APP_SOCKET_URL_V2}/last-tick/${symbolInfo.ticker}/${convertedResolution}`,
    )

    socketIo.current.onmessage = ({ data }: any) => {
      try {
        const response = JSON.parse(data)

        for (let i = 0; i < response.t.length; ++i) {
          const barValue: Bar = {
            time: moment().unix() * 1000,
            close: parseFloat(response.c[i]),
            open: parseFloat(response.o[i]),
            high: parseFloat(response.h[i]),
            low: parseFloat(response.l[i]),
            volume: parseFloat(response.v[i]),
          }

          onTick(barValue)
        }
      } catch (error) {}
    }
  },
  unsubscribeBars: () => {},
})
